import React from 'react';
import { PopupHuchaCardContainer } from '../../../ui/popup-hucha-card-container';
import { PopupHuchaRenovadoresCardC2 } from './popup-hucha-renovadores-card-c2';
import { PopupHuchaRenovadoresCardC3 } from './popup-hucha-renovadores-card-c3';

export const PopupHuchaRenovadoresCard: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	return (
		<PopupHuchaCardContainer>
			<PopupHuchaRenovadoresCardC2 dineroHucha={dineroHucha} />
			<PopupHuchaRenovadoresCardC3 />
		</PopupHuchaCardContainer>
	);
};
